<template>
  <div class="fill-height"
    :style="[
      {'background-color': `#F4F4F4`} 
    ]"
  >
    <strategio-app-bar :search-props="searchProps" :search-items="searchItems"></strategio-app-bar>
    <v-main>
      <transition name="expansionbusq">
        <div v-if="!hideSearchBar">
          <v-container class="hidden-sm-and-up">
            <v-row>
              <v-col cols="12" style="background-color: white">
                <v-card id="filter-textfield">
                  <v-text-field
                    v-model.lazy="searchProps.searchCriteria"
                    append-icon="search" 
                    label="Buscar en Strategio"
                    hide-details="auto"
                    full-width
                    single-line
                    type="search"
                    @keyup.enter="searchItems()"
                  ></v-text-field>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
import PasswordExpireWarning from '../components/dialogs/password-expire-warning.vue'

        </div>
      </transition>
      <!-- <structure-list :structures="heritableStructures" :contained-by="containedBy" :is-searching="searchInfo !== ''" :search-info="searchInfo"></structure-list> -->
      <!-- {{ heritableFolders }} -->
      <!-- <structure-list v-if="isAdmin && containedBy === undefined || 0" :folders="heritableFolders" :contained-by="containedBy" :is-searching="searchInfo !== ''" :search-info="searchInfo"></structure-list> -->
      <div v-if="loading" class="strategio-loading-main">
        <p>
          <v-progress-circular style="color:#00C3D7;" indeterminate size="50"></v-progress-circular>
          <br />
          <span class="strategio-loading-main-message">
            Un momento por favor
          </span>
        </p>
      </div>
      <div 
        v-else
        style="overflow: hidden; padding-left: 0px;"
      >
        <!-- <structure-list
          v-if="isAdmin && (searchInfo === '') && heritableFolders.length > 0 && isMainPage"
          :folders="heritableFolders"
          :contained-by="containedBy"
          :is-searching="searchInfo !== ''"
          :search-info="searchInfo"
          :add-inner-folder="addInnerFolder"
          :add-inner-report="addInnerReport"
        ></structure-list> -->

        <header-main-page v-if="isMainPage"></header-main-page>
        <!-- más usados y favoritos -->
        <v-container>
          <v-row 
            v-if="isMainPage && (searchInfo === '')">
            <v-col cols="12" md="8" lg="12" xl="12" >
              <div class="strategio-title-mas-usados">
                <v-icon x-large color="#000000" style="-webkit-text-stroke: 1px #000;">ico-icon-heart</v-icon>
                Más usados
              </div>
              <report-list
                :reports="topFrecuenteReports"
              ></report-list>
            </v-col>

            <!-- <v-col cols="12" md="6" lg="4" xl="4">
              <div class="strategio-title-favorite">
                Favoritos y novedades
              </div>
              <report-list
                :reports="topNovedadesReports"
                :rectangle="true"
              ></report-list>
            </v-col> -->
          </v-row>
        </v-container>
        
        
        <folder-list
          :to-update-toggle="toUpdateToggle"
          :to-update-on="foldersToUpdateMode"
          :to-update="foldersInheriteeToUpdate"
          :folders="folders"
          :contained-by="containedBy"
          :is-searching="searchInfo !== ''"
          :search-info="searchInfo"
          :add-inner-folder="addInnerFolder"
          :add-inner-report="addInnerReport"
        ></folder-list>
        <report-list
          :reports="reports"
          :contained-by="containedBy"
          :is-searching="searchInfo !== ''"
          :search-props="searchProps"
          :search-items="searchItemsByTag"
        ></report-list>

      </div>
      <v-speed-dial
        id="options-button"
        fixed
        v-model="fab"
        bottom
        right
        direction="top"
        transition="scale-transition"
        elevation-6
        v-if="isAdmin"
        v-show="searchInfo === ''"
        class="strategio-speed-dial"
        
      >
        <v-btn
          slot="activator"
          fab
          hover
          v-model="fab"
        >
          <v-icon v-if="fab">close</v-icon>
          <v-icon v-else>add</v-icon>
          
        </v-btn>
        <v-tooltip left open-on-hover>
          <v-btn
            fab
            small
            slot="activator"
            @click="addReport()"
          >
            <v-icon style="font-size:26px" color="grey darken-1">note_add</v-icon>
          </v-btn>
          <span>Crear reporte</span>
        </v-tooltip>
        <v-tooltip left open-on-hover>
          <v-btn
            fab
            small
            slot="activator"
            @click="addFolder()"
          >
            <v-icon style="font-size:26px" color="grey darken-1">create_new_folder</v-icon>
          </v-btn>
          <span>Crear folder</span>
        </v-tooltip>
        <!-- <v-tooltip v-if="false" left open-on-hover>
          <v-btn
            fab
            small
            color="white"
            slot="activator"
            @click="createSructure()"
          >
            <v-icon style="font-size:26px" color="grey darken-1">content_copy</v-icon>
          </v-btn>
          <span>Copiar estructura</span>
        </v-tooltip> -->
        <!-- <v-tooltip v-if="false" left open-on-hover>
          <v-btn
            fab
            small
            color="white"
            slot="activator"
            @click="pasteStructure()"
          >
            <v-icon style="font-size:26px" color="grey darken-1">content_paste</v-icon>
          </v-btn>
          <span>Pegar estructura</span>
        </v-tooltip> -->
        <v-tooltip
          left open-on-hover
          v-if="isMainPage"
        >
          <v-btn
            fab
            small
            slot="activator"
            @click="setFoldersToUpdateModeOn()"
          >
            <v-icon style="font-size:26px" color="grey darken-1">reply</v-icon>
          </v-btn>
          <span>Vincular a base</span>
        </v-tooltip>
      </v-speed-dial>
    </v-main>

    <custom-snack-bar></custom-snack-bar>
    <folder-form-dialog></folder-form-dialog>
    <report-form-dialog></report-form-dialog>
    <new-items-manager-dialog></new-items-manager-dialog>
    <drop-item-dialog></drop-item-dialog>
    <replicate-folder-dialog></replicate-folder-dialog>
    <!-- <structure-form-dialog></structure-form-dialog> -->
    <!-- <paste-structure-form-dialog></paste-structure-form-dialog> -->
    <show-users-folder-permissions></show-users-folder-permissions>
  </div>
</template>

<script>
import {map, filter, orderBy} from 'lodash'

import eventBus from '../utils/eventBus'
import introBus from '../utils/introBus'

import StructureList from '../components/structures/structure-list.vue'
import FolderList from '../components/folders/folder-list.vue'
import ReportList from '../components/reports/report-list.vue'
import StrategioAppBar from '../components/header-bar/strategio-app-bar.vue'
import HeaderMainPage from '../components/header-main-page/header-main-page.vue'

import FolderFormDialog from '../components/dialogs/folder-form-dialog.vue'
import ReportFormDialog from '../components/dialogs/report-form-dialog.vue'
import DropItemDialog from '../components/dialogs/drop-item-dialog.vue'
import ReplicateFolderDialog from '../components/dialogs/replicate-folder-dialog.vue'
import StructureFormDialog from '../components/dialogs/structure-form-dialog.vue'
import NewItemsManagerDialog from '../components/dialogs/new-items-manager-dialog.vue'
import PasteStructureFormDialog from '../components/dialogs/paste-structure-form-dialog.vue'
import ShowUsersFolderPermissions from './../components/dialogs/show-users-folder-permissions.vue'

import CustomSnackBar from '../components/snackbars/custom-snack-bar.vue'

import userStorage from '../storage/userStorage'
import reportsStorage from '../storage/reportsStorage'
import structureStorage from '../storage/structureStorage'

export default {
  name: 'main-page',
  data () {
    return {
      heritableFolders: [],
      foldersToUpdateMode: false,
      foldersInheriteeToUpdate: [],
      folders: [],
      reports: [],
      topFavoriteReports: [],
      topFrecuenteReports: [],
      topNovedadesReports: [],
      containedBy: 0,
      loading: false,
      firstTimeMenu: false,
      isAdmin: userStorage.getUserInfo().userType === 'ADMIN',
      daysTillPasswordChange: userStorage.getUserInfo().daysTillPasswordChange,
      fab: false,
      searchInfo: '',
      searchCriteria: '',
      hideSearchBar: true,
      showDialog: false,
      searchProps: {
        searchCriteria: ''
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    // react to route changes...
    // don't forget to call next()
    this.searchProps.searchCriteria = ''
    this.searchInfo = ''

    // this.loadFolders(to.params.folderID)
    this.loadAll(to.params.folderID, false)
    next()
  },
  mounted () {
    if (this.daysTillPasswordChange < 10 && this.$route.params.firstTimeMenu === true) {
      eventBus.$emit('open-custom-snack-bar', {message: `Su contraseña expira en ${this.daysTillPasswordChange} días`, itsOk: false})
    }

    this.loadAll(this.$route.params.folderID)
    eventBus.$off('start-main-page-tutorial')
    eventBus.$on('start-main-page-tutorial', () => {
      let intro = introBus.getIntroBus()
      intro.setOption('doneLabel', 'Continuar')
      intro.addSteps([
        {
          element: '#filter-textfield',
          intro: 'Desde aquí podrá realizar el filtrado de los reportes'
        },
        {
          element: '#options-button',
          intro: 'Desde aquí se podrán crear reportes y carpetas'
        },
        {
          element: '#reportlistfolder0',
          intro: 'Estas son las carpetas donde los reportes serían agrupados'
        },
        {
          element: '#reportlistitem0',
          intro: 'Estos son reportes individuales'
        },
        {
          element: '#addfavortite-button',
          intro: 'Con este botón se podrá agregar reportes a favoritos. A continuación se verá las opciones disponibles cuando acceda a uno de estos reportes'
        }
      ].filter((obj) => {
        return document.getElementById(obj.element.split('#')[1])
      }))
      intro.start()
      intro.oncomplete(() => {
        const anyItem = (item) => !item.isFolder
        reportsStorage.getData({
          onSuccess: (response) => {
            if (response.length > 0 && response.find(anyItem)) {
              this.$router.push(`/show-report/${response.find(anyItem).itemID}?main-page=true`)
            }
          }
        })
      })
    })

    eventBus.$off('toggle-search-bar')
    eventBus.$on('toggle-search-bar', () => {
      this.hideSearchBar = !this.hideSearchBar
    })
  },
  created () {
    eventBus.$off('reload-items')
    eventBus.$on('reload-items', (data) => {
      this.searchProps.searchCriteria = ''
      this.searchInfo = ''

      this.loadAll(this.$route.params.folderID, true)
    })
  },
  methods: {
    setFoldersToUpdateModeOn () {
      this.foldersToUpdateMode = true
    },
    toUpdateToggle () {
      this.foldersToUpdateMode = false
      map(this.foldersInheriteeToUpdate, (item) => {
        item.checked = false
      })
    },
    getHeritables (_forceLoad, _onSuccess) {
      // structureStorage.getStructures({
      structureStorage.getHeritableItems({
        forceLoad: _forceLoad,
        onSuccess: (items) => {
          let folders = orderBy(filter(items, (item) => {
            return (
              item.isFolder === 1 &&
              item.containedBy === '0'
              // A los items que cumplan con lo previo
              //  asignales el parametro de heredable
              // assign(item, {heritable: 1})
            )
          }), (item) => {
            // Si tiene 'H' o 'HI' (provienen de heredables)
            // ordenarlas, moverlas para el final
            // return /^(HI?)(\d+)$/.exec(item.itemID)[1]
            return item.itemID.startsWith('HI')
          })

          this.heritableFolders.splice(0)
          this.heritableFolders.push(...folders)

          _onSuccess && _onSuccess()
        }
      })
    },
    loadAll (_folderID, _forceLoad) {
      if (_forceLoad) {
        this.getHeritables(true, // forceLoad
          () => { // onSuccess
            if (this.isAdmin && String(_folderID).startsWith('H')) {
              this.loadStructures(_folderID)
              // this.loadStructures(_folderID)
            }
          }
        )
        // Actualiza el árbol total de items antes de traer
        //  los items de este directorio
        reportsStorage.getData({
          forceLoad: true,
          onSuccess: () => {
            // eslint-disable-next-line
            if (!String(_folderID).startsWith('H')) {
              this.loadFolders(_folderID)
            }
          }
        })
      } else {
        if (this.isAdmin && String(_folderID).startsWith('H')) {
          this.loadStructures(_folderID)
        } else {
          this.loadFolders(_folderID)
        }
      }
    },
    loadStructures (_folderID, _forceLoad) {
      this.loading = !structureStorage.isHeritableDataLoaded()
      const folderID = _folderID || '0'
      const forceLoad = _forceLoad || false
      structureStorage.getHeritableItems({
        forceLoad,
        onSuccess: (items) => {
          const _folders = []
          const _reports = []

          let data = filter(items, (item) => item.containedBy === folderID)

          filter(data, (item, index) => {
            if (item.isFolder) {
              // assign(item, {heritable: 1}) // Es necesario?
              _folders.push(item)
            } else {
              // item.imageUrl = item.imageUrl || 'http://via.placeholder.com/320x150?text=imageUrl'
              _reports.push(item)
            }
          })

          this.loading = false
          this.folders = _folders
          this.reports = _reports
          this.containedBy = structureStorage.findHeritableItemByID(folderID)

          eventBus.$emit('enable-tutorial-button')
        },
        onError: (err) => {
          console.warn('!!!!!', 'error', err)
        }
      })
    },
    loadFolders (_folderID, _forceLoad) {
      this.loading = !reportsStorage.isDataLoaded()
      const folderID = _folderID || '0'
      const forceLoad = _forceLoad || false
      this.isAdmin && this.getHeritables() // Solo si es administrador
      reportsStorage.getData({
        forceLoad,
        folderID,
        onSuccess: (data) => {
          const _folders = []
          const _reports = []

          this.foldersInheriteeToUpdate.splice(0)
          this.foldersToUpdateMode = false
          map(data, (item, index) => {
            if (item.isFolder) {
              _folders.push(item)
              this.foldersInheriteeToUpdate.push({itemID: item.itemID, checked: false})
            } else {
              // item.imageUrl = item.imageUrl || 'http://via.placeholder.com/320x150?text=imageUrl'
              _reports.push(item)
            }
          })

          if (folderID === '0') {
            let topReports = reportsStorage.getTopReports()
            this.topFavoriteReports = topReports.topFavoriteReports
            this.topFrecuenteReports = topReports.topFrecuenteReports
            this.topNovedadesReports = topReports.topNovedadesReports
          }

          this.loading = false
          this.folders = _folders
          this.reports = _reports
          this.containedBy = reportsStorage.findItemByID(folderID)

          eventBus.$emit('enable-tutorial-button')
        },
        onError: (error) => {
          let message = 'Error desconocido'
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
            message = 'No pudimos obtener respuesta del servidor'
          } else {
            // Something happened in setting up the request that triggered an Error
            message = `Error desconocido: ${error.message}`
          }
          this.loading = false
          // emits to components/snackbars/custom-snack-bar.vue
          eventBus.$emit('open-custom-snack-bar', {message, itsOk: false})
        }
      })
    },
    searchItems () {
      const searchQuery = this.searchProps.searchCriteria.trim().split(/\s+/)
      let isValid = true
      for (let i = 0; i < searchQuery.length; i++) {
        if (searchQuery[i].length < 3) {
          isValid = false
          break
        }
      }

      if (!isValid) {
        eventBus.$emit('open-custom-snack-bar', {message: 'Las palabras deben tener al menos 3 letras', itsOk: 'warning'})
        return
      }

      const data = reportsStorage.searchItems(searchQuery)

      const _folders = []
      const _reports = []
      data.map((item, index) => {
        if (item.isFolder) {
          _folders.push(item)
        } else {
          _reports.push(item)
        }
      })
      this.folders = _folders
      this.reports = _reports
      if (data.length > 0) {
        this.searchInfo = `${_reports.length} reportes y ${_folders.length} carpetas en ${data.length}/${reportsStorage.storeLength()} elementos`
      } else {
        this.searchInfo = 'No se encontraron elementos que coincidan con la búsqueda'
      }
      // this.containedBy = reportsStorage.findItemByID(folderID)
      /*
        TODO: la busqueda y muestra estan listos.
        * Ahora tenemos que utilizar una estrategia de renderizado para no relentizar la app.
        * Podemos hacer que la longitud minima de la busqueda sea de 3. Sin contar espacios(user trim-split)
        * Una forma de regresar a la carpeta de origen
        * Idear una forma de limpiar el cuadro de busquedas. Sobre todo cuando vamos de carpeta a carpeta
      */
    },
    searchItemsByTag () {
      const searchQuery = this.searchProps.searchCriteria.trim().split(/\s+/)
      let isValid = true
      /* for (let i = 0; i < searchQuery.length; i++) {
        if (searchQuery[i].length < 3) {
          isValid = false
          break
        }
      } */

      if (!isValid) {
        eventBus.$emit('open-custom-snack-bar', {message: 'Las palabras deben tener al menos 3 letras', itsOk: 'warning'})
        return
      }

      const data = reportsStorage.searchItems(searchQuery)

      const _folders = []
      const _reports = []
      data.map((item, index) => {
        if (item.isFolder) {
          _folders.push(item)
        } else {
          _reports.push(item)
        }
      })
      this.folders = _folders
      this.reports = _reports
      if (data.length > 0) {
        this.searchInfo = `${_reports.length} reportes y ${_folders.length} carpetas en ${data.length}/${reportsStorage.storeLength()} elementos`
      } else {
        this.searchInfo = 'No se encontraron elementos que coincidan con la búsqueda'
      }
      // this.containedBy = reportsStorage.findItemByID(folderID)
      /*
        TODO: la busqueda y muestra estan listos.
        * Ahora tenemos que utilizar una estrategia de renderizado para no relentizar la app.
        * Podemos hacer que la longitud minima de la busqueda sea de 3. Sin contar espacios(user trim-split)
        * Una forma de regresar a la carpeta de origen
        * Idear una forma de limpiar el cuadro de busquedas. Sobre todo cuando vamos de carpeta a carpeta
      */
    },
    addReport () {
      const parentFolder = this.$route.params.folderID
      // emit to components/dialogs/report-form-dialog.vue
      eventBus.$emit('open-report-form', {
        containedBy: parentFolder,
        heritable: this.containedBy && this.containedBy.heritable,
        parentName: this.containedBy && this.containedBy.itemName,
        structureID: this.containedBy && this.containedBy.origin
      })
    },
    addInnerReport (folderData) {
      const parentFolder = folderData.itemID
      // emit to components/dialogs/report-form-dialog.vue
      eventBus.$emit('open-report-form', {
        containedBy: parentFolder,
        heritable: !!folderData.heritable,
        parentName: folderData.itemName,
        structureID: folderData.origin
      })
    },
    addFolder () {
      const parentFolder = this.$route.params.folderID
      // emit to components/dialogs/folder-form-dialog.vue
      eventBus.$emit('open-folder-form', {
        itemName: 'Nueva carpeta',
        containedBy: parentFolder,
        heritable: this.containedBy && this.containedBy.heritable,
        structureID: this.containedBy && this.containedBy.origin
      }, this.heritableFolders) // Para el combo de heredables
    },
    addInnerFolder (folderData) {
      const parentFolder = folderData.itemID
      // emit to components/dialogs/folder-form-dialog.vue
      eventBus.$emit('open-folder-form', {
        itemName: 'Nueva carpeta',
        containedBy: parentFolder,
        heritable: !!folderData.heritable,
        structureID: folderData.origin
      }, this.heritableFolders) // Para el combo de heredables
    },
    createSructure () {
      const folderName = this.containedBy ? this.containedBy.itemName : 'REPORTES'
      eventBus.$emit('open-structure-form', {structureName: `Estructura de ${folderName}`, structureItems: this.reports})
    },
    pasteStructure () {
      eventBus.$emit('open-paste-structure-form-dialog', {})
    }
  },
  computed: {
    isMainPage: function () {
      return this.$route.params.folderID === '0'
    },
    haveFavoriteReport: function () {
      return this.topFavoriteReports.length > 0
    }
  },
  components: {
    StructureList,
    FolderList,
    ReportList,
    StrategioAppBar,
    HeaderMainPage,
    FolderFormDialog,
    ReportFormDialog,
    DropItemDialog,
    ReplicateFolderDialog,
    StructureFormDialog,
    NewItemsManagerDialog,
    PasteStructureFormDialog,
    ShowUsersFolderPermissions,
    CustomSnackBar
  }
}
</script>
<style>
.strategio-loading-main {
  text-align: center;
  margin-top: 128px;
}
.strategio-loading-main-message {  
  font-weight: 500;
  font-size: 18px;
  color: black;
}

.expansionbusq-enter-active {
  transition: max-height .2s linear;
  max-height: 112px;
  padding: 0;
  overflow: hidden;
}
.expansionbusq-leave-active {
  transition: max-height .1s linear;
  max-height: 0px;
  padding: 0;
  overflow: hidden;
}
.expansionbusq-enter {
  max-height: 0px;
  padding: 0;
  opacity: 0;
}
.expansionbusq-leave {
  max-height: 112px;
  padding: 0;
  opacity: 0;
}

.strategio-title-mas-usados {
  font-family: 'Nexa-Bold';
  font-style: normal;
  font-weight: 400;
  font-size: 50px;
  line-height: 52px;
  color: #000000;
  -webkit-text-stroke: 1px #000;
  padding-left: 20px;
}

.strategio-title-favorite {
  font-family: 'Nexa-Bold';
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 43px;
  color: #000000;
  -webkit-text-stroke: 1px #000;
  padding-left: 20px;
  padding-top: 5px;
}

</style>


// WEBPACK FOOTER //
// src/routes/main-page.vue